export default "__VITE_ASSET__C0OMl_rI__"